(() => {
  const initialize = (scope) => {
    scope.querySelectorAll('[data-dibao-page]').forEach((page) => {
      if (page.dataset.pageEnhanced === 'true') return;
      page.dataset.pageEnhanced = 'true';
      const content = page.querySelector('[data-dibao-page-content]');
      if (!content) return;
      const english = document.documentElement.lang.toLowerCase().startsWith('en');
      const headings = Array.from(content.querySelectorAll('h2'));

      if (page.classList.contains('dibao-page--contact')) {
        Array.from(content.children).forEach((chapter) => {
          if (chapter.tagName !== 'DIV' || !chapter.querySelector('h2')) return;
          chapter.classList.add('dibao-page__chapter');
          const heading = chapter.querySelector('h2').textContent.trim();
          const variants = [
            ['contact', /聯[絡繫]方式|contact (?:methods|details)/i],
            ['flow', /回收流程|buyback process|how it works/i],
            ['preparation', /提供.*資料|準備|prepare|information to provide/i],
            ['area', /服務地區|service area/i],
            ['faq', /常見問題|frequently asked|faq/i],
            ['links', /相關資訊|related information|useful links/i],
          ];
          const variant = variants.find(([, pattern]) => pattern.test(heading));
          if (variant) chapter.classList.add(`dibao-page__chapter--${variant[0]}`);
          chapter.querySelectorAll(':scope > p').forEach((paragraph) => {
            const label = paragraph.querySelector('strong');
            if (label && /WhatsApp|WeChat/i.test(label.textContent)) {
              paragraph.classList.add('dibao-page__contact-method');
            }
          });
        });
      }

      if (headings.length >= 3) {
        const toc = document.createElement('details');
        toc.className = 'dibao-page__toc';
        const summary = document.createElement('summary');
        summary.textContent = english ? 'On this page' : '本頁內容';
        const nav = document.createElement('nav');
        nav.setAttribute('aria-label', english ? 'Page sections' : '頁面章節');
        const list = document.createElement('ol');
        headings.forEach((heading, index) => {
          if (!heading.id) {
            let id = `${content.id}-chapter-${index + 1}`;
            while (document.getElementById(id)) id += '-section';
            heading.id = id;
          }
          const item = document.createElement('li');
          const link = document.createElement('a');
          link.href = `#${heading.id}`;
          link.textContent = heading.textContent.trim();
          item.append(link);
          list.append(item);
        });
        nav.append(list);
        toc.append(summary, nav);
        page.querySelector('.dibao-page__hero').after(toc);
      }

      content.querySelectorAll('table').forEach((table) => {
        if (table.parentElement.classList.contains('dibao-page__table-scroll')) return;
        const wrapper = document.createElement('div');
        wrapper.className = 'dibao-page__table-scroll';
        wrapper.tabIndex = 0;
        wrapper.setAttribute('role', 'region');
        wrapper.setAttribute('aria-label', english ? 'Table; scroll horizontally for all columns' : '資料表；可左右捲動查看全部欄位');
        table.before(wrapper);
        wrapper.append(table);
      });
    });
  };

  initialize(document);
  document.addEventListener('shopify:section:load', (event) => {
    initialize(event.target.parentElement || document);
  });
})();
